import * as React from "react";

const SvgLocationPin = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
<g  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill="currentColor" stroke="none">
<path d="M2425 5114 c-459 -46 -827 -216 -1135 -524 -542 -542 -682 -1357
-351 -2045 69 -144 1497 -2454 1547 -2502 62 -60 160 -53 215 17 40 52 1415
2351 1465 2450 82 164 136 328 171 520 21 116 23 425 4 545 -63 398 -234 738
-511 1015 -275 275 -624 452 -1009 510 -80 12 -330 21 -396 14z m345 -309
c311 -44 625 -201 849 -426 211 -211 348 -467 412 -769 33 -152 33 -430 1
-580 -30 -139 -74 -264 -132 -380 -27 -52 -334 -571 -683 -1153 l-634 -1059
-661 1065 c-363 586 -681 1105 -705 1153 -98 196 -145 379 -154 604 -27 691
414 1304 1077 1499 199 59 420 75 630 46z"/>
<path d="M2397 4205 c-338 -64 -617 -324 -708 -660 -31 -114 -32 -335 -1 -450
68 -251 244 -466 475 -580 142 -70 224 -88 397 -88 173 -1 253 17 397 88 232
114 407 328 475 580 31 115 30 336 -1 450 -85 312 -338 565 -646 645 -106 28
-283 35 -388 15z m285 -296 c96 -20 208 -80 284 -152 77 -72 124 -143 162
-245 22 -58 26 -84 26 -187 1 -128 -9 -175 -62 -280 -72 -147 -231 -271 -393
-310 -373 -88 -738 200 -739 582 0 98 15 163 61 262 72 155 233 286 403 327
65 16 190 17 258 3z"/>
</g>
  </svg>
);

export default SvgLocationPin;
